import React, { lazy } from "react";
import Support from "../views/Support";

const SignIn = lazy(() => import("../views/SignIn.view"))
const PasswordRecovery = lazy(() => import("../views/PasswordRecovery"))
const PrivacyPolicy = lazy(() => import("../views/PrivacyPolicy"))
const Terms = lazy(() => import("../views/TermsAndConditions"))

export const publicRotues = [
  {
    path: "/sign-in",
    element: <SignIn />,
  },
  {
    path: "/password-recovery",
    element: <PasswordRecovery />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/support",
    element: <Support />
  }
];